module.exports = __webpack_public_path__ + "img/vertical-logo.a9872ab9.svg";